export enum VpnStatus {
  Unknown = 'Unknown',
  Detected = 'Detected',
  NotDetected = 'NotDetected',
}
